import HlsJS from "hls.js";
import throttle from "lodash.throttle";

const track = window.track;

const throttledEvents = new Map();

export default class Analytics {
    static init () {
        track.load("https://events.forzasys.com");
    }

    static event (name, body) {

        body = body || {};
        const id = "tag:" + name;
        console.debug("AnalyticsEvent:", id, body);
        try {
            track.track(id, body);
        } catch (e) {
            console.error(e);
        }
    }

    static throttledEvent (name, body, wait=1000) {
        /*
        Throttle function that ensures that we dont spam too many events.
        Useful if we attach events to dom handlers that might be triggered many times per second.
        The first call gets invoked immediately. Subsequent calls may be delayed.
        The last event will always have the correct values.
         */
        let f = throttledEvents.get(name);
        if (!f) {
            f = throttle(Analytics.event, wait, {trailing:true});
            throttledEvents.set(name, f);
        }
        return f(name, body);
    }

    static streamEvent (stream, name, body={}) {
        Analytics.event(name, {
            stream: `${stream.server.name}:${stream.game.id}`,
            ...body
        });
    }

    static applyVideoListeners (hlsjs, videoElement, stream) {
        hlsjs.on(HlsJS.Events.ERROR, (e, data) => {
            try {
                switch(data.type) {
                    default:
                        let text = data.details;
                        if (data.reason) {
                            text += ": reason: " + data.reason;
                        }
                        if (data.response) {
                            text += ": " + data.response.code + ": " + data.response.text;
                        }
                        Analytics.streamEvent(stream, "video_error", {
                            type: data.type,
                            details: text,
                            fatal: data.fatal,
                        });
                        break;
                }
            } catch (e) {
                console.error(e);
            }
        });

        hlsjs.on(HlsJS.Events.FRAG_LOADED, (e, data) => {
            const {trequest, tload} = data.stats;
            const loadTime = (tload - trequest) / 1000;
            if (loadTime > 1) {
                let url = undefined;
                if (data.frag && data.frag.relurl) {
                    url = data.frag.relurl;
                }
                Analytics.streamEvent(stream, "slow_download", {
                    duration: loadTime,
                    url: url,
                });
            }
        });

        hlsjs.on(HlsJS.Events.LEVEL_LOADED, (e, data) => {
            const {trequest, tload} = data.stats;
            const loadTime = (tload - trequest) / 1000;
            Analytics.streamEvent(stream, "manifest_load", {
                duration: loadTime,
            });
        });

        videoElement.addEventListener('waiting', () => {
            Analytics.streamEvent(stream, "stall");
        });

        videoElement.addEventListener('pause', () => {
            Analytics.streamEvent(stream, "paused");
        });

    }

}


// WEBPACK FOOTER //
// ./src/js/include/Analytics.js